import React, { forwardRef } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import type { RootState } from 'src/redux/rootReducerType';

interface Props {
  selectedCount: number;
  onSubmit: () => void;
  onCancel: () => void;
}

export const SelectionActionBar = forwardRef<HTMLDivElement, Props>(
  function SelectionActionBar(
    { selectedCount, onSubmit, onCancel },
    ref
  ): React.ReactElement {
    const theme = useTheme();
    const bottomNavHeight = useSelector(
      (state: RootState) => state.newRenterUI.bottomNavHeight
    );

    return (
      <Box
        ref={ref}
        role="toolbar"
        aria-label="Selection actions"
        sx={{
          position: 'fixed',
          bottom: bottomNavHeight,
          left: 0,
          right: 0,
          bgcolor: 'background.paper',
          borderTop: `1px solid ${theme.palette.divider}`,
          px: 2,
          pt: 2,
          pb: 4.5,
          zIndex: 10,
        }}
      >
        <Stack spacing={1.25}>
          <Button
            variant="contained"
            fullWidth
            disabled={selectedCount === 0}
            onClick={onSubmit}
            sx={{
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              borderRadius: '16px',
              py: 1.75,
              fontSize: 15,
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': { bgcolor: 'primary.dark' },
              '&.Mui-disabled': {
                bgcolor: 'action.disabledBackground',
                color: 'action.disabled',
              },
            }}
          >
            Answer these questions again
          </Button>
          <Button
            variant="text"
            fullWidth
            onClick={onCancel}
            sx={{
              color: 'text.secondary',
              fontSize: 15,
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    );
  }
);
